import { Box, Button, CircularProgress, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import FileSaver from "file-saver";
import {itemMasterfilterColArry} from "./data"
import { constraintsOptions, inputTypes, selectOptKeyName } from "data/globalData";
import { DownloadRounded } from "@mui/icons-material";
import { getColDefaultValue, isColumnDefault } from "components/EboStoreV4/data";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import { AuthState } from "context/AuthContext";

const ItemMaster = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [loading, setLoading] = useState(false);
	const { user } = AuthState();
	const [filterColumns, setFilterColumns] = useState(itemMasterfilterColArry);
	const [brand, setBrand] = useState([])
	const [division, setDivision] = useState([])
	const [season, setSeason] = useState([])
	const [department, setDepartement] = useState([])

	const defaultData = itemMasterfilterColArry?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});

	const [filterData, setFilterData] = useState({ ...defaultData });

	const fetchDropdownValues = async () => {
		// api call to fetch dropdown values.
		setLoadingOpen(true);
		try {
			await pythonVmInstance.get("custom_queries/item_master/get_filters").then((res) => {
				console.log("first res", res.data);
				const message = res?.data?.message
				const result = res?.data?.result[0]
				const status = res?.data?.status

				setBrand(result.brand)
				setDivision(result.division)
				setSeason(result.season)
				setDepartement(result.department)

				setLoadingOpen(false);
				setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: message,
				severity: status,
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			});
		} catch (error) {
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "unable to fetch values for dropdown",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};

	useEffect(() => {
		fetchDropdownValues();
	}, []);

	const handleDownloadItemMaster = async (e) => {
		e.preventDefault();
		setLoading(true);
		let pendingFields = [];
		itemMasterfilterColArry?.forEach((attr) => {
			if (isColumnDefault(attr, filterData?.[attr?.key]) && attr?.constraints?.[constraintsOptions.NOTNULL.key] === true)
				pendingFields.push(attr);
		});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);

			return;
		}

		let show_cogs = false
		if (user?.role?.ADMIN || user?.role?.COGS) show_cogs = true

		try {
			await pythonVmInstance({
				url: `/custom_queries/item_master/download`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "post",
				responseType: "blob",
				data: {
					...filterData,show_cogs
				},
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `ITEM_MASTER_${new Date().toISOString().split("T")[0]}.csv`);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Downloaded the file",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoading(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			console.log("asdfghjkl", error);
			setSnackBar({
				...snackBar,
				message: `failed to run query ${error}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
		}
	};
console.log('filterData',filterData)
	return (
		<Stack spacing={2} component="form" onSubmit={handleDownloadItemMaster}>
			{/* <Typography variant="h6">All Channel Dispatch</Typography> */}
			{/* form */}
			<Box display="flex" columnGap={2} flexWrap={"wrap"} justifyContent={""} rowGap={2} pt={2}>
				{filterColumns?.map((col) => {
					if (col?.key === 'season'){
						col = { ...col, select_options: { ...col.select_options, list: season, getOptionLabel: (value) =>({name: value, key: value}) } };
					}
					if (col?.key === 'brand'){
						col = { ...col, select_options: { ...col.select_options, list: brand, getOptionLabel: (value) =>({name: value, key: value}) } };
					}
					if (col?.key === 'division'){
						col = { ...col, select_options: { ...col.select_options, list: division, getOptionLabel: (value) =>({name: value, key: value}) } };
					}
					if (col?.key === 'department'){
						col = { ...col, select_options: { ...col.select_options, list: department, getOptionLabel: (value) =>({name: value, key: value}) } };
					}
					return (
						<RenderInputField
							column={col}
							data={filterData}
							setData={setFilterData}
							selectOptObjName={"select_options"}
							width={"20%"}
							// selectOptObjName={selectOptKeyName}
							longWidth={"300px"}
							disabled={false}
							disableLabel={true}
						/>
					);
				})}

				<Box alignSelf="flex-end" pb={1}>
					<Button
						variant="contained"
						sx={{ width: "200px" }}
						type="submit"
						disabled={loading}
						startIcon={loading ? <CircularProgress color="inherit" size="20px" /> : <DownloadRounded />}>
						{loading ? "Loading..." : "Download"}
					</Button>
				</Box>
			</Box>
		</Stack>
	);
};

export default ItemMaster;
